export interface HighlightSegment {
  text: string;
  highlighted: boolean;
}

function escapeRegex(text: string): string {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/** Split text into safe, renderable highlighted and unhighlighted segments. */
export function highlightSegments(text: string, tokens: string[]): HighlightSegment[] {
  const uniqueTokens = [...new Set(tokens.filter(Boolean))].sort(
    (left, right) => right.length - left.length,
  );

  if (!uniqueTokens.length) return [{ text, highlighted: false }];

  const matcher = new RegExp(uniqueTokens.map(escapeRegex).join('|'), 'gi');
  const segments: HighlightSegment[] = [];
  let cursor = 0;

  for (const match of text.matchAll(matcher)) {
    const index = match.index ?? 0;
    if (index > cursor) segments.push({ text: text.slice(cursor, index), highlighted: false });
    segments.push({ text: match[0], highlighted: true });
    cursor = index + match[0].length;
  }

  if (cursor < text.length) segments.push({ text: text.slice(cursor), highlighted: false });
  return segments.length ? segments : [{ text, highlighted: false }];
}
